module.exports = __webpack_public_path__ + "img/blog14.35c34595.jpg";